import Material from './Material';
import Phase from './Phase';
import Process from './Process';

interface PlasticAssessmentItem {
    id: number;
    assessmentId: number;
    description: string;
    purchaseResponsible: string;
    processId: number;
    phaseId: number | null;
    quantity: number;
    quantityInStock: number | null;
    unitOfMeasure: number;
    materialId: number;
    acquisition: 'direct' | 'supplier';
    alternativeAvailable: boolean | string;
    alternativeDescription: string | null;
    alternativeCost: number | null;
    replaceable: boolean | string;
    replaceableReason: string | null;
    replaceableDuration: number | null;
    kpiId: number | null;
    process?: Process;
    phase?: Phase;
    material?: Material;
    createKpi: boolean;
    alreadyReplaced: boolean;
    action: string;
    alternativeMaterial: number | null;
    alternativeWeight: number | null;
    itemCategory: any | null;
    averageConsume: number | null;
    reductionTarget: number | null;
    dueDate: string | null;
    monitoringFrequency: 'monthly' | 'bimonthly' | 'quarterly';
    co2UsageMonthly: number | null;
}

const EmptyPlasticAssessmentItem: PlasticAssessmentItem = {
    id: 0,
    assessmentId: 0,
    description: '',
    purchaseResponsible: '',
    processId: 0,
    phaseId: null,
    quantity: 0,
    quantityInStock: null,
    unitOfMeasure: 1,
    materialId: 0,
    acquisition: 'direct',
    alternativeAvailable: false,
    alternativeDescription: null,
    alternativeCost: null,
    replaceable: false,
    replaceableReason: null,
    replaceableDuration: null,
    kpiId: null,
    createKpi: true,
    alreadyReplaced: false,
    action: 'removal',
    alternativeMaterial: null,
    alternativeWeight: null,
    itemCategory: null,
    averageConsume: null,
    reductionTarget: null,
    dueDate: null,
    monitoringFrequency: 'monthly',
    co2UsageMonthly: null
};

export { EmptyPlasticAssessmentItem };

export default PlasticAssessmentItem;
